import { Injectable } from '@angular/core';
import { concat, map, Observable, of, shareReplay } from 'rxjs';
import { instantInterval } from './rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimeGenerator {
  public readonly $NowEverySecond: Observable<Date> = concat(of(new Date()), instantInterval(1000)).pipe(
    shareReplay(),
    map(() => new Date()),
  );
}
